export const style = {
  appBar: {
    position: 'sticky',
    spacing: 2,
    sx: {
      backgroundColor: 'primary.contrast',
      p: 1,
    },
  },
  stack: {
    direction: 'row',
    spacing: 2,
    sx: {
      ml: 3,
      flexGrow: 1,
      justifyContent: 'center',
    },
  },
} as const;
